import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

type VisitLike = {
    prefetch?: boolean;
};

/**
 * Indica se há uma visita Inertia em andamento (exceto prefetch).
 * Útil para botões de ação que disparam `router.get/post/delete` diretamente.
 */
export function useInertiaLoading(): boolean {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let activeVisits = 0;

        const markStart = () => {
            activeVisits += 1;
            setLoading(true);
        };

        const markEnd = () => {
            activeVisits = Math.max(0, activeVisits - 1);
            if (activeVisits === 0) {
                setLoading(false);
            }
        };

        const offStart = router.on('start', (event) => {
            const visit = event.detail.visit as VisitLike;
            if (visit.prefetch) {
                return;
            }
            markStart();
        });

        const offFinish = router.on('finish', markEnd);
        const offCancel = router.on('cancel', markEnd);
        const offError = router.on('error', markEnd);
        const offInvalid = router.on('invalid', markEnd);
        const offException = router.on('exception', markEnd);

        return () => {
            offStart();
            offFinish();
            offCancel();
            offError();
            offInvalid();
            offException();
            activeVisits = 0;
        };
    }, []);

    return loading;
}

/**
 * Loading scoped a uma ação local: só fica true após `arm()` e enquanto Inertia navega.
 */
export function useScopedInertiaLoading() {
    const globalLoading = useInertiaLoading();
    const [armed, setArmed] = useState(false);

    useEffect(() => {
        if (!globalLoading) {
            setArmed(false);
        }
    }, [globalLoading]);

    return {
        loading: armed && globalLoading,
        arm: () => setArmed(true),
    };
}
